import { CHANGEPASSWORD_FAIL, CHANGEPASSWORD_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const changePasswordReducer = (state = initialState, action) => {
	switch (action.type) {
		case CHANGEPASSWORD_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case CHANGEPASSWORD_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default changePasswordReducer;
